import Color from 'color'
import { Element, ElementContent, Properties, Text } from 'hast'
import { Plugin } from 'unified'
import { remove } from 'unist-util-remove'
import { visit } from 'unist-util-visit'

/**非サポートのbタグをサポート対象のstrongタグに変換する */
export const rehypeConvertFromBTagToStrongTag: Plugin = () => {
  return tree => {
    visit(tree, 'element', (node: Element) => {
      if (node.tagName === 'b') {
        node.tagName = 'strong'
      }
    })
  }
}

/** 非サポートのiタグをサポート対象のemタグに変換する */
export const rehypeConvertFromITagToEmTag: Plugin = () => {
  return tree => {
    visit(tree, 'element', (node: Element) => {
      if (node.tagName === 'i') {
        node.tagName = 'em'
      }
    })
  }
}

/** aタグのマークアップを `アンカーテキスト[URL]` に変換する */
export const rehypeConvertFromATagToText: Plugin = () => {
  return tree => {
    visit(tree, 'element', (node: Element, index, parent: Element) => {
      if (node.tagName === 'a' && node.properties && node.properties['href']) {
        const url = node.properties['href']
        const text = node.children
          .map((child: ElementContent) => {
            if (child.type === 'text') {
              return (child as Text).value
            }
            return ''
          })
          .join('')
        parent.children[index] = {
          type: 'text',
          value: `${text}[${url}]`,
        }
      }
    })
  }
}

/**
 * <span style="color: …"> を常に #rrggbb へ正規化する Rehype プラグイン
 *
 * Tiptap エディタがRGB表記を返す場合があるため、常に #rrggbb へ正規化する.
 * 解析できない値（色名など）はそのまま残す
 */
export const rehypeHexColor: Plugin = () => {
  return tree => {
    visit(tree, 'element', (node: Element) => {
      if (node.tagName === 'span' && node.properties && node.properties['style']) {
        const styleAttr: string = node.properties['style'] as string

        const styleMap: Record<string, string> = Object.fromEntries(
          styleAttr
            .split(';')
            .map(d => d.split(':').map(s => s.trim()))
            .filter(a => a.length === 2)
        )

        if (styleMap['color']) {
          try {
            styleMap['color'] = Color(styleMap['color']).hex().toLowerCase()
          } catch {
            /**  不正な値はスルーする. */
          }
        }

        ;(node.properties as Properties)['style'] = Object.entries(styleMap)
          .map(([k, v]) => `${k}: ${v}`)
          .join(';')
      }
    })
  }
}

/** HTMLのコメントを削除するRehype プラグイン.*/
export const remarkStripHtmlComments: Plugin = () => {
  return tree => {
    remove(tree, (node: any) => {
      if (node.type === 'text') {
        return /^\s*<!--/.test((node as Text).value)
      }
      return false
    })
  }
}

/** attributes が存在しないspanタグを削除する */
export const rehypeRemoveNoAttributeSpanTag: Plugin = () => {
  return tree => {
    visit(tree, 'element', (node: Element, index, parent: Element) => {
      if (node.tagName === 'span' && Object.keys(node.properties).length === 0) {
        parent.children.splice(index, 1, ...node.children)
      }
    })
  }
}
